(function () {
    if (window.__customFeatureCollectionProductsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.customFeatureCollectionProducts = window.Branch.customFeatureCollectionProducts || {};
    window.Branch.customFeatureCollectionProducts.sliders = window.Branch.customFeatureCollectionProducts.sliders || {};

    window.__customFeatureCollectionProductsHasFired = true;


  function resizefeaturedProductsSlider(uninitializedCustomFeatureCollectionProducts){
    let slider = uninitializedCustomFeatureCollectionProducts;
        let sectionId = slider.closest('.shopify-section') && slider.closest('.shopify-section').getAttribute('id').replaceAll('shopify-section-', '');
        let maxWidth = 0;
        let productTileInfoContainers = document.querySelectorAll(`#shopify-section-${sectionId} .c-fcp-slider__outer-container .product-tile[data-type="expandable"] .product-tile__info-container`);
        if(productTileInfoContainers.length > 0){
          productTileInfoContainers.forEach((productTileInfoContainer) => {
            productTileInfoContainer.style.height = ``;
          })
          productTileInfoContainers.forEach((productTileInfoContainer) => {
            if (parseInt(productTileInfoContainer.offsetHeight) > maxWidth){
              maxWidth = parseInt(productTileInfoContainer.offsetHeight);
            }
          })
          productTileInfoContainers.forEach((productTileInfoContainer) => {
            productTileInfoContainer.style.height = `${maxWidth}px`;
          })
        }
  }


    function initFeaturedProductsSlider(uninitializedSlider, parent){
        uninitializedSlider.setAttribute('data-initialized', true);
        let uninitializedSliderSwiper = uninitializedSlider.querySelector('.c-fcp-slider__outer-container');
        let sectionId = uninitializedSlider.closest('.shopify-section') && uninitializedSlider.closest('.shopify-section').getAttribute('id').replaceAll('shopify-section-', '');
        const sliderContainer = parent.querySelector(`.c-fcp-slider__outer-container`);
        let swiperInstance = null;

        function shouldEnableSwiper() {
          const limitToThreeChild = parent.querySelector('.c-fcp-section--limit-to-three');
          const screenWidth = window.innerWidth;
          return !(screenWidth <= 766 && limitToThreeChild);
        }

        if(sectionId){
            function initSwiper() {
              swiperInstance = new Swiper(sliderContainer, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                freeMode: true,
                navigation: {
                  prevEl: `#shopify-section-${sectionId} .c-fcp-arrow-container .c-fcp-arrow-left`,
                  nextEl: `#shopify-section-${sectionId} .c-fcp-arrow-container .c-fcp-arrow-right`,
                },
                breakpoints: {
                  767: {
                    slidesPerView: parseInt(uninitializedSliderSwiper.getAttribute('data-mobile-tablet-slides-per-view')),
                    spaceBetween: 20,
                    width: null,
                  },
                  1024: {
                    slidesPerView: parseInt(uninitializedSliderSwiper.getAttribute('data-small-desktop-slides-per-view')),
                    spaceBetween: 20,
                    width: null,
                  },
                  1280: {
                    slidesPerView: parseInt(uninitializedSliderSwiper.getAttribute('data-large-desktop-slides-per-view')),
                    spaceBetween: 20,
                    width: null,
                  }
                },
                on: {
                  init: function () {
                    resizefeaturedProductsSlider(uninitializedSliderSwiper);
                  },
                }
              });

              window.Branch.customFeatureCollectionProducts.sliders[`${sectionId}`] = swiperInstance;
            }

          function destroySwiper() {
            if (swiperInstance && swiperInstance.destroy) {
              swiperInstance.destroy(true, true);
              swiperInstance = null;
              delete window.Branch.customFeatureCollectionProducts.sliders[`${sectionId}`];
            }
          }

          function updateSwiperBasedOnConditions() {
            if (shouldEnableSwiper()) {
              if (!swiperInstance) {
                initSwiper();
              }
            } else {
              destroySwiper();
            }
          }

          updateSwiperBasedOnConditions();
          window.addEventListener('resize', () => {
            updateSwiperBasedOnConditions();
          });
        }

      
    }

    function actionsOnVisible(uninitializedCustomFeatureCollectionProducts, parent){
      console.log('actionsOnVisible');
      uninitializedCustomFeatureCollectionProducts.setAttribute('data-interacted', true);
      initFeaturedProductsSlider(uninitializedCustomFeatureCollectionProducts, parent)

        window.addEventListener('resize', function(){
          setTimeout(function(){
              resizefeaturedProductsSlider(uninitializedCustomFeatureCollectionProducts); 
          }, 400);
      })
    }

    function initCustomFeatureCollectionProductsCallback(uninitializedCustomFeatureCollectionProducts, parent, type){
        let fromLoad = uninitializedCustomFeatureCollectionProducts.closest('.homepage-content-container') && uninitializedCustomFeatureCollectionProducts.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(uninitializedCustomFeatureCollectionProducts, parent);
        }
        else if(!uninitializedCustomFeatureCollectionProducts.closest('.homepage-content-container')){
          actionsOnVisible(uninitializedCustomFeatureCollectionProducts, parent);    
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = uninitializedCustomFeatureCollectionProducts.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                uninitializedCustomFeatureCollectionProducts.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(uninitializedCustomFeatureCollectionProducts, parent);
                uninitializedCustomFeatureCollectionProducts.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.customFeatureCollectionProducts.initCustomFeatureCollectionProducts = function(type){
      console.log('initCustomFeatureCollectionProducts')
        let uninitializedcustomFeatureCollectionProducts = document.querySelectorAll('.shopify-section.c-fcp-section:not([data-initialized="true"])');
        uninitializedcustomFeatureCollectionProducts.forEach((uninitializedCustomFeatureCollectionProducts) => {
            let parent = uninitializedCustomFeatureCollectionProducts.closest('.shopify-section');
            uninitializedCustomFeatureCollectionProducts.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initCustomFeatureCollectionProductsCallback(uninitializedCustomFeatureCollectionProducts, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initCustomFeatureCollectionProductsCallback,  '.homepage-content-container', uninitializedCustomFeatureCollectionProducts, uninitializedCustomFeatureCollectionProducts, parent);
            }
        })
    }

    if (document.readyState === "complete") {
        window.Branch.customFeatureCollectionProducts.initCustomFeatureCollectionProducts('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.customFeatureCollectionProducts.initCustomFeatureCollectionProducts('regular'));
    }
  })();
